/**
 * The global AgGrid options.
 *
 * @type {Object}
 */
export default {
    animateRows: false,
    domLayout: 'autoHeight',
    groupDisplayType: 'multipleColumns',
    includeHiddenColumnsInQuickFilter: true,
    pagination: true,
    paginationPageSize: 20, // base page size

    rowGroupPanelShow: 'onlyWhenGrouping',
    rowSelection: 'multiple',

    showOpenedGroup: false,
    suppressPaginationPanel: true,
    suppressRowClickSelection: true,

    sideBar: {
        hiddenByDefault: false,
        defaultToolPanel: '',
        position: 'right',
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                minWidth: 225,
                maxWidth: 225,
                width: 225,
                toolPanelParams: {
                    suppressPivotMode: true,
                    suppressRowGroups: true,
                    suppressValues: true,
                },
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
                minWidth: 180,
                maxWidth: 400,
                width: 250,
            },
        ],
    },

    tooltipInteraction: false,
    tooltipShowDelay: 2000,
    tooltipHideDelay: 5000,
}
